import React from "react";

interface AnimatedSparklesProps {
  count?: number;
  className?: string;
}

const AnimatedSparkles: React.FC<AnimatedSparklesProps> = ({
  count = 6,
  className = "",
}) => {
  return (
    <div className={`absolute inset-0 pointer-events-none ${className}`}>
      {[...Array(count)].map((_, i) => (
        <div
          key={i}
          className="absolute w-2 h-2 bg-blue-400/30 rounded-full animate-ping"
          style={{
            top: `${Math.random() * 100}%`,
            left: `${Math.random() * 100}%`,
            animationDelay: `${Math.random() * 3}s`,
            animationDuration: `${2 + Math.random() * 2}s`,
          }}
        />
      ))}
    </div>
  );
};

export default AnimatedSparkles;
